import { FileText, Loader2, History } from "lucide-react";
import { formatDateTime } from "./ui";

export default function DemoRequestQuoteSection({ current, quoteCreating, onCreateQuote, onViewQuote }) {
  if (current.status !== "Completed") return null;
  const history = current.quote_history || [];
  return (
    <section className="rounded-2xl border border-violet-200 bg-violet-50/40 p-5 dark:border-violet-500/20 dark:bg-violet-500/10" data-testid="demo-quote-section">
      <h3 className="text-sm font-bold text-slate-950 dark:text-white">Quote</h3>
      {current.quote_id ? (
        <>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">A quote has already been created for this demo request.</p>
          <button
            type="button"
            onClick={onViewQuote}
            data-testid="view-quote-btn"
            className="mt-3 inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition-colors duration-200 hover:bg-slate-50 dark:border-white/15 dark:bg-white/5 dark:text-slate-200 dark:hover:bg-white/10"
          >
            <FileText size={16} /> View Quote ({current.quote_id})
          </button>
        </>
      ) : (
        <>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">Create a quote for {current.company} based on this completed demo.</p>
          <button
            type="button"
            onClick={onCreateQuote}
            disabled={quoteCreating}
            data-testid="create-quote-btn"
            className="mt-3 inline-flex items-center gap-2 rounded-xl bg-[#0052FF] px-4 py-2.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-blue-700 disabled:opacity-50"
          >
            {quoteCreating ? <Loader2 size={16} className="animate-spin" /> : <FileText size={16} />}
            Create Quote
          </button>
        </>
      )}

      {history.length > 0 && (
        <div className="mt-4 border-t border-violet-200/60 pt-3 dark:border-violet-500/20" data-testid="demo-quote-history">
          <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.1em] text-violet-700 dark:text-violet-400">
            <History size={13} /> Past Quotes
          </p>
          <ul className="mt-2 space-y-1.5">
            {history.slice().reverse().map((entry, idx) => (
              <li
                key={`${entry.quote_id}-${idx}`}
                data-testid={`demo-quote-history-item-${entry.quote_id}`}
                className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-white/70 px-3 py-2 text-xs text-slate-600 dark:bg-white/5 dark:text-slate-400"
              >
                <span className="font-bold text-slate-700 dark:text-slate-300">{entry.quote_id}</span>
                <span>Deleted {formatDateTime(entry.removed_at)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
